import builder from '../builder';
import PictureSun from '../../streamline-icons/bold/picture-sun.svg';

export default builder('IconPictureSunBold', PictureSun);
